<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('overduePayment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('overduePayment.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('overduePayment.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('overduePayment.acYear')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.ac_year_id"
                        :options="ac_year_list"
                        @change="acYearChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_year_id')">
                        {{ errors.first('ac_year_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('overduePayment.subProgram') }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.acps_id"
                        :options="sub_programs"
                        :show-search="true"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        @change="onSubChange"
                        :disabled="!model.ac_year_id"
                      ></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('overduePayment.acTerm') }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.ac_term_id"
                        :options="ac_terms"
                        :show-search="true"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        @change="acTermChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('overduePayment.classOperation') }}</label>
                      <treeselect
                        :options="class_options"
                        :placeholder="$t('all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.class_id"
                      ></treeselect>
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('overduePayment.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'overduePayment',
  data() {
    return {
      loading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      sub_programs: [],
      ac_terms: [{ value: null, label: 'All' }],
      ac_year_list: [],
      class_options: [],
      model: {
        acps_id: null,
        ac_term_id: '',
        ac_year_id: null,
        class_id: []
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportPayment', [
      'overduePayment',
      'getSubProgram',
      'getTerm',
      'getYear',
      'getClass'
    ]),
    async fetchData() {
      this.loading = true
      await this.getSubProgram().then(response => {
        this.sub_programs = [
          { value: null, label: 'All' },
          ...response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        ]
      })
      await this.getYear()
        .then(response => {
          this.ac_year_list = response.data.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSubChange(acps_id) {
      this.model.ac_term_id = ''
      this.model.class_id = []
      this.loading = true
      this.getTerm({
        filter: {
          acps_id: acps_id,
          ac_status_id: '1,2',
          ac_year_id: this.model.ac_year_id
        }
      })
        .then(response => {
          this.ac_terms = [
            { value: null, label: 'All' },
            ...response.data.map(el => ({
              value: el.ac_term_id,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : null)
            }))
          ]
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    acYearChange() {
      this.model.acps_id = null
      this.model.ac_term_id = ''
      this.model.class_id = []
    },
    acTermChange(ac_term_id) {
      if(!ac_term_id){
        return
      }
      this.loading = true
      this.getClass({
        filter: {
          ac_term_id: ac_term_id
        }
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label: el.class_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.overduePayment(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
